import { datadogRum } from '@datadog/browser-rum';
import { useCallback, useContext } from 'react';
import PageEventContext from '|/context/page-event-context';

const useRumAction = () => {
  const pageContext = useContext(PageEventContext);

  const trackAction = useCallback(
    (name: string, context?: Record<string, unknown>) => {
      datadogRum.addAction(name, { ...(pageContext ?? {}), ...(context ?? {}) });
    },
    [pageContext]
  );

  return { trackAction };
};

export default useRumAction;
